import { pushToDataLayer } from '@domain-group/fe-helper';
export default () => event => {
  pushToDataLayer(event);
};